<template>
  <v-app>
    <add-section v-if="dialogSection.open" />
    <v-main :class="{'edit-bg': $route.name === 'BodyEdit'}">
      <router-view />
    </v-main>
    <one-checkout
      v-if="infos && String(infos['event-id'])"
      ref="oneCheckout"
      :evento="String(infos['event-id'])"
    />
    <v-overlay :value="loading" color="white">
      <v-progress-circular indeterminate size="65" color="primary"></v-progress-circular>
    </v-overlay>
    <img
      v-if="infos && idFacebook"
      height="1"
      width="1"
      style="display:none"
      :src="
        `https://www.facebook.com/tr?id=${idFacebook}&ev=PageView&noscript=1`
      "
    />
    <v-snackbar
      :timeout="3000"
      width="100"
      :color="snackbar.color"
      v-model="snackbar.open"
    >
      <v-row justify="center" no-gutters>
        <h4>{{ snackbar.message }}</h4>
      </v-row>
    </v-snackbar>
    <v-footer
      v-if="!cookiesAccepted && $route.name !== 'BodyEdit'"
      fixed
      color="rgba(25, 43, 70, 0.85)"
      :height="$vuetify.breakpoint.mdAndUp ? '100px' : '250px'"
      class="px-16"
    >
      <v-row no-gutters align="center" justify="center">
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'">
          <span style="font-size: 14px !important" class="white--text"
            >Utilizamos cookies para oferecer melhor experiência, melhorar o
            desempenho, analisar como você interage em nosso site e personalizar
            conteúdo. Ao utilizar este site, você concorda com o uso de
            cookies.</span
          >
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          :class="$vuetify.breakpoint.mdAndUp ? '' : 'mt-2'"
          align="center"
          :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
        >
          <v-btn rounded depressed color="primary" @click="acceptCookies">
            OK
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import AddSection from "./components/edit/dialogs/AddSection";
import OneCheckout from "./components/one-checkout/one-checkout.vue";

export default {
  components: { OneCheckout, AddSection },
  name: "App",

  data() {
    return {
      idFacebook: "",
      cookiesAccepted: true,
      intervalToGetVisits: null,
      firstRender: true
    };
  },

  computed: {
    ...mapGetters(["infos", "dialogSection", "hotsite", "hotsiteSelectedVersion", "loading", "snackbar", "campaings"]),
  },

  watch: {
    async hotsiteSelectedVersion (version, oldVersion) {
      if (version !== oldVersion && oldVersion) {
        const newParams = {...this.$route.params, version: version}
        this.$router.replace({name: 'BodyEdit', params: newParams})
        this.$store.dispatch('setNav', {open: true, sectionId: ''})
        window.scrollTo({behavior: 'smooth', top: 0})
        await this.getHotsite()
      }
    }
  },

  created() {
    this.getHotsite()
    this.getSaveConfig()
  },

  mounted() {
    if (this.$route.name !== "BodyEdit") this.cookiesVerification();
  },

  destroyed() {
    clearInterval(this.intervalToGetVisits);
  },

  methods: {
    getHt() {
      const uuidv1 = require("uuid/v1");
      const htsetted = localStorage.getItem("ht");
      if (!htsetted) localStorage.setItem("ht", uuidv1().substring(0, 6));
    },

    visits(timer) {
      const ht = localStorage.getItem("ht");
      this.$store.dispatch("handleAnalytics", {
        event: this.infos["event-id"],
        ht: ht,
        url: timer ? document.URL + `!time=${timer}` : document.URL,
        device: window.navigator.userAgent,
        referer: document.referrer,
      });
    },

    startTimerToGetVisits() {
      let timer = 0;

      this.intervalToGetVisits = setInterval(() => {
        timer++;

        if (timer === 15) this.visits(timer);
        if (timer === 30) this.visits(timer);
        if (timer === 60) this.visits(timer);
      }, 1000);
    },

    cookiesVerification() {
      if (!this.$cookies.get("cookies-accepted")) {
        this.cookiesAccepted = false;
      }
    },

    acceptCookies() {
      this.$cookies.set("cookies-accepted", true, {
        path: "/",
        expires: 0,
      });
      this.cookiesAccepted = true;
    },

    async getHotsite() {
      let domain = "";
      localStorage.getItem("currentUserToken");

      if (
        document.URL.search("localhost") !== -1 ||
        document.URL.search("blueticket.com.br") !== -1 ||
        document.URL.search("btservers.com.br") !== -1 ||
        document.URL.search("cloudfront.net") !== -1
      ) {
        domain = null;
      } else domain = document.URL.split("/")[2];

      await this.$store.dispatch("getHotsite", {
        slug: this.$route.params.slug,
        version: this.$route.params.version,
        domain: domain,
      });

      let version = null;

      if (
        this.hotsite.versao_publicada &&
        this.hotsite.versao_publicada.configuracoes &&
        this.$route.params.version === undefined
      )
        version = this.hotsite.versao_publicada.configuracoes;

      if (
        this.hotsite.versao_especifica &&
        this.hotsite.versao_especifica.configuracoes &&
        this.$route.params.version !== undefined
      ) {
        version = this.hotsite.versao_especifica.configuracoes;
      }

      await this.$store.dispatch("setInfos", JSON.parse(version));

      if (this.$route.name === "BodyEdit") {
        const defaultPage = this.infos.pages.find(page => page.route === '/')      
        this.$store.dispatch('setSelectedPage', defaultPage.id)
        
        this.setVersionAfterCreate()
        await this.$store.dispatch('getHotSiteVersions', {
          codigo_organizador: this.hotsite.codigo_organizador,
          codigo_hotsite: this.hotsite.codigo,
          token: this.$route.params.token
        })
      }

      if (this.firstRender) {
        this.getHt();
        this.getInfos();
        this.getTickets();
        this.visits();
        this.startTimerToGetVisits();
      }

      this.firstRender = false
    },

    getTickets() {
      this.$store.dispatch("getTickets", this.infos["event-id"]);
    },

    getSaveConfig() {
      this.$store.dispatch("setSaveConfig", this.getInfos.bind(this));
    },

    getIdFacebook() {
      if (this.infos)
        this.idFacebook = this.infos.integrations["facebook-pixel"];
    },

    getInfos() {
      if (this.infos) {
        if (!this.$route.path.includes("/edit/")) this.getIntegrations();
        document.title = this.infos.title;
        document.getElementById("favicon").href = this.infos.favicon;
        const bodyStyle = document.body.style
        const defaultFont = this.infos.layout[0].default.font
        const defaultColor = this.infos.layout[0].default.color

        const setStyle = (currentStyle, defaultValue) => {
          if (currentStyle) return currentStyle
          else return defaultValue
        }

        bodyStyle.setProperty("--font-family-text", setStyle(this.infos.layout[0].text.font, defaultFont))
        bodyStyle.setProperty("--font-family-b", setStyle(this.infos.layout[0].subtitle.font, defaultFont))
        bodyStyle.setProperty("--font-family-h1", setStyle(this.infos.layout[0].title.font, defaultFont))
        bodyStyle.setProperty("--color-text", setStyle(this.infos.layout[0].text.color, defaultFont))
        bodyStyle.setProperty("--color-b", setStyle(this.infos.layout[0].subtitle.color, defaultColor))
        bodyStyle.setProperty("--color-h1", setStyle(this.infos.layout[0].title.color, defaultColor))
        bodyStyle.setProperty("--font-family-default", setStyle(defaultFont))

        bodyStyle.setProperty("--rounded-radius", this.infos.layout[0].button["border-radius"])
        bodyStyle.setProperty("--background-color-button", this.infos.layout[0].button["background-color"])
        bodyStyle.setProperty("--color-button",this.infos.layout[0].button["color"])
        if (this.infos.layout[0].button["font"]) bodyStyle.setProperty("--background-color-button", this.infos.layout[0].button["font"])

        this.$store.dispatch("getSpeakers", this.infos["event-id"]);
        this.$store.dispatch("getProgram", this.infos["event-id"]);
        this.$store.dispatch("getProducts", this.infos["event-id"]);
        this.$store.dispatch("getLogos", this.infos["event-id"]);
        this.$store.dispatch("getSponsors", this.infos["event-id"]);
        this.$store.dispatch("getFaq", this.infos["event-id"]);

        if (this.$route.name === "BodyEdit") {
          this.$store.dispatch("getCampaigns", {
            event: this.infos["event-id"],
            token: this.$route.params.token,
          });
        }
      }
    },

    getIntegrations() {
      this.idFacebook = "";
      let facebookPixel = this.infos.integrations["facebook-pixel"];
      let googleTag = this.infos.integrations["google-tag-manager"];
      let googleAnalytics = this.infos.integrations["google-analytics"];
      this.getIdFacebook();
      document.getElementById("facebook").innerHTML = !(function(
        f,
        b,
        e,
        v,
        n,
        t,
        s
      ) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );
      fbq("init", facebookPixel);
      document.getElementById("google-tag").innerHTML = (function(
        w,
        d,
        s,
        l,
        i
      ) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", googleTag);
      document.getElementById("google-analytics").innerHTML = (function(
        i,
        s,
        o,
        g,
        r,
        a,
        m
      ) {
        i["GoogleAnalyticsObject"] = r;
        (i[r] =
          i[r] ||
          function() {
            (i[r].q = i[r].q || []).push(arguments);
          }),
          (i[r].l = 1 * new Date());
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(
        window,
        document,
        "script",
        "https://www.google-analytics.com/analytics.js",
        "ga"
      );

      ga("create", googleAnalytics, "auto");
      ga("send", "pageview");
    },

    setVersionAfterCreate() {
      if (this.hotsite && this.hotsite.versao_especifica)
        this.$store.commit('SET_HOTSITE_SELECTED_VERSION', this.hotsite.versao_especifica.codigo)
    }
  },
};
</script>

<style>
:root {
  --font-family-h1: "";
  --font-family-b: "";
  --font-family-text: "";
  --color-h1: "black";
  --color-b: "black";
  --color-text: "black";

  --rounded-radius: 5px;
  --background-color-button: white;
  --color-button: black;

  --font-family-button: "";
  --font-family-default: Inter;
}

* {
  margin: 0;
  font-family: var(--font-family-default), sans-serif;
}

.v-btn {
  background-color: var(--background-color-button) !important;
  text-transform: none !important;
  color: var(--color-button) !important;
  border-radius: var(--rounded-radius) !important;
  font-family: var(--font-family-button) !important;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-thumb {
  background-color: #DFE0E3;
  border-radius: 5px;
  /* background-clip: content-box; */
}

::-webkit-scrollbar-track {
  background-color: white; 
}

.v-navigation-drawer__content::-webkit-scrollbar {
  width: 10px !important;
}

.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: rgba(245, 247, 249, 1) !important;
  border-radius: 5px !important;
}

.v-navigation-drawer__content::-webkit-scrollbar-track {
  background-color: white !important; 
}

h1 {
  font-size: var(--font-size-h1);
  font-family: var(--font-family-h1);
  color: var(--color-h1);
}

b {
  font-family: var(--font-family-b);
  color: var(--color-b);
}

span {
  font-family: var(--font-family-text);
  color: var(--color-text);
}

ul, ol {
  display: inline-block !important;
}

.pointer {
  cursor: pointer;
}

.editCard:hover {
  box-shadow: inset 0 0 0 3px #0067af !important;
}

.edit-bg {
  background-color: #ededef;
}

/* .font {
  font-family: Inter !important;
} */

.font *:not(.v-icon) {
  font-family: inherit !important;
}

.rowEdit {
  z-index: 1 !important;
  position: absolute !important;
  left: 50% !important;
  transform: translate(-50%) !important;
  display: unset !important;
  flex-direction: none !important;
  margin: 0;
}

.cardMenu {
  border: 1px solid #1976d2;
  background: #e3eef9;
  height: 48px;
  width: 226px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

._styles-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

._divider {
  margin: 16px -8px 16px -8px;
  border: none;
  height: 1px;
  background-color: rgba(102, 109, 128, 0.1);
} 

._titleFormFont {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  text-align: left;
  color: #192b46;
}

._subtitleFormFont {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
  color: #484D5C;
  padding-bottom: 8px
}

._subtitleFormFontSmall {
  font-size: 11px;
}

._pl- {
  padding-left: 4px !important;
}

._pr- {
  padding-right: 4px !important;
}

._pr {
  padding-right: 8px !important;
}

._pt {
  padding-top: 12px !important;
}

._pt_plus {
  padding-top: 20px !important;
}

._dialog-title {
  color: #0079CB;
  font-size: 18px;
  font-weight: 700;
}

._dialog-title2 {
  color: #484D5C;
  font-size: 18px;
  font-weight: 700;
}

._menu-section-style {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 100px; /* 100px é provisório!!! apenas para distanciar o menu antigo do atual */
}

._cursor-move {
  padding: 8px;
  border-radius: 8px;
  cursor: move !important;
  transition: all 0.3s;
}

._cursor-move:hover {
  background-color: #FAFBFB;
}

._btn {
  transition: all 0.3s;
}

._btn button:hover {
  background-color: #CBCBCE !important;
}

@keyframes _fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.btnEdit {
  background-color: transparent !important;
  margin: 0px 3px !important;
  width: 38px !important;
  color: white !important;
}

.v-text-field label,
.v-text-field input {
  font-family: Inter, sans-serif !important;
}

.v-textarea label,
.v-textarea input {
  font-family: Inter, sans-serif !important;
}
</style>
